import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUserContext } from '../context/UserContext'
import RoutePermission from './RoutePermission'

const UnAuthGuard = ({ component }) => {
  const navigate = useNavigate()
  const { getSessionUser } = useUserContext()

  useEffect(() => {
    let cancelled = false

    ;(async () => {
      const sessionUser = getSessionUser()
      if (!sessionUser) return

      const home = await RoutePermission.defaultLandingPage(sessionUser)
      if (cancelled) return

      navigate(home, { replace: true })
    })()

    return () => {
      cancelled = true
    }
  }, [navigate, getSessionUser])

  return <React.Fragment>{component}</React.Fragment>
}

export default UnAuthGuard
